module.exports = __webpack_public_path__ + "img/login_tab02_05.e13f1194.png";